import { useQuery, UseQueryResult } from "@tanstack/react-query";
import config from "../config.json";
import { IPageable, Params } from "../types/table/interfaces.type";
import { createAxiosInstance } from "./ServicesHelpers";

interface IRoutingCost {
  id: string;
  cost: number;
  effectiveDate: Date;
  comment: string;
  isDeleted: boolean;
  vendorConnectionProfileId: string;
  operatorId: number;
  updatedBy?: string;
  /** GET /routing-costs list filter */
  costValue?: number;
  costComparison?: "GT" | "LT" | "EQ";
}

const axiosInstance = createAxiosInstance(config.ADMIN_API_BASE_URL);

export const fetchRoutingCosts = async (
  params: Params<IRoutingCost>
): Promise<IPageable<IRoutingCost>> => {
  try {
    console.log("Fetching routing-costs...");
    const response = await axiosInstance.get("/routing-costs", { params });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching routing-costs:", error.message || error);
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while fetching the routing-costs."
    );
  }
};

export const fetchRoutingCost = async (
  id: IRoutingCost["id"]
): Promise<IRoutingCost> => {
  try {
    console.log(`Fetching routing-costs/${id}...`);
    const response = await axiosInstance.get(`/routing-costs/${id}`);
    return response.data;
  } catch (error: any) {
    console.error(
      `Error fetching routing-costs/${id}:`,
      error.message || error
    );
    throw new Error(
      error.response?.data?.message ||
        `An error occurred while fetching the routing-costs/${id}.`
    );
  }
};



export const useRoutingCostQuery = (
  params: Params<IRoutingCost>
): UseQueryResult<IPageable<IRoutingCost>, Error> => {
    const effectiveParams = {
    ...params,
    sort: params.sort || "createdDate,desc",
  };

  const queryKey = ["routingCost", JSON.stringify(effectiveParams)];
  return useQuery({
    queryKey,
    queryFn: () => fetchRoutingCosts(effectiveParams),
  });
};